import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHtml5,
  faCss3,
  faJs,
  faReact,
  faBootstrap,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";

import "./TechStack.css";

export default function TechStack() {
  return (
    <div>
      <div className="container-custom stack">
        <div className="mb-3">
          <h2>My Tech Stack</h2>
          <p>Technologies I’ve been working with recently</p>
        </div>
        <div className="d-md-flex justify-content-between">
          <FontAwesomeIcon icon={faHtml5} className="fa-brands" />
          <FontAwesomeIcon icon={faCss3} className="fa-brands" />
          <FontAwesomeIcon icon={faGithub} className="fa-brands" />
          <FontAwesomeIcon icon={faJs} className="fa-brands" />
          <FontAwesomeIcon icon={faBootstrap} className="fa-brands" />
          <FontAwesomeIcon icon={faReact} className="fa-brands" />
        </div>
      </div>
    </div>
  );
}
